<template>
  <div class="leftbar-view elffy-dashboard" :class="{'left-aside-toggle': toggle_aside}">
    <!--Page Container Start Here-->
    <section class="main-container">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-12">
            <div class="material-table-widget dashboard_top_bar">
              <div class="row">
                <div class="col-md-6 col-md-offset-3">
                 <h3 class="text-center" style="margin:6px 0px;"><b>{{filter_year}}年度業務分析 - {{current_user_name}}</b></h3>
                </div> 
                <div class="col-md-3 form-inline text-right display-block">
                  <select v-model="filter_year" class="form-control" @change="queryData">
                    <option v-for="year in year_range" v-bind:value="year">{{year}}</option>
                  </select>
                  <select v-model="filter_sales" class="form-control" @change="queryData">
                    <option value="all">所有人</option>
                    <option v-for="user in company_users" v-bind:value="user.user_tag">{{user.user_name}}</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="widget-wrap padding-0" v-if="filter_sales=='all'">
              <h3>團隊績效：達成率 {{floatRound(allValue/allTarget)}} <br><small>總達成金額：$ {{allValue.toLocaleString()}} , 總業績目標：$ {{allTarget.toLocaleString()}}</small></h3>
              <div class="row">
                <div class="col-8">
                  <div ref="chart_team_revenue" style="width: 100%; height: 400px;"></div>
                </div>
                <div class="col-4 text-left">
                  <div style="position:relative;height:100px;" v-for="user in orderedUserByValue">
                    <img style="margin-top:20px;" class="avatar-size" v-bind:src="user.avatar">
                    <div style="position:absolute;left:45px;top:0px">
                      <span>{{user.user_name}}</span> (<span>{{floatRound(user.total_target/user.expect_target)}}</span>)
                      <br>
                      <span class="text-gray">完成金額：$ {{user.total_target.toLocaleString()}}</span><br>
                      <span class="text-gray">目標金額：$ {{user.expect_target.toLocaleString()}}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="widget-wrap padding-0">
              <div class="">
              </div>
              <div class="row">
                <div class="col" v-for="title in deals_title">
                  <h3 class="text-success" v-if="title=='won'">已成交訂單：{{dealTotal(title)}}</h3>
                  <h3 class="text-danger" v-else-if="title=='lost'">已丟失訂單：{{dealTotal(title)}}</h3>
                  <h3 class="text-info" v-else-if="title=='all'">總訂單：{{dealTotal(title)}}</h3>
                  <small>{{dealCount(title)}}筆 / {{dealRate(title)}}</small>
                  </div>
                </div>
              <!-- <hr>
              <p>平均成交定金額(成交總金額/成交總數) = {{avgPrice}}</p> -->
            </div>
            <div class="row">
              <div class="col-6">
                <div class="widget-wrap padding-0">
                  <div class="deal_sidebar block-header clearfix"><div class="pull-left"><p>每月成交金額</p></div></div>
                  <div class="widget-container">
                    <div ref="chartdiv" style="width: 100%; height: 400px;"></div>
                  </div>
                </div>
              </div>
              <div class="col-6">
                <div class="widget-wrap padding-0">
                  <div class="deal_sidebar block-header clearfix"><div class="pull-left"><p>各階段轉換率</p></div></div>
                  <div class="widget-container">
                    <div class="widget-content">
                      <div ref="chart_funnel" style="width: 100%; height: 400px;"></div>
                      <!-- <div class="row">
                        <div class="col" v-for="name in stages_name">
                          <h4>{{name}}</h4>
                          <p>總共{{stages_data[name]}}筆 <span class="badge badge-pill badge-primary">{{stageRate(stages_data[name])}}</span></p>
                          <p>轉換率 <span class="badge badge-pill badge-primary">{{transferRate(stages_data[name], name)}}</span></p>
                        </div>
                      </div> -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div> 
        </div>
      </div>
    </section>
    <!--Page Container End Here-->
  </div>
</template>
 <script src="https://www.amcharts.com/lib/4/themes/animated.js"></script>
<script>
  import * as am4core from "@amcharts/amcharts4/core";
  import * as am4charts from "@amcharts/amcharts4/charts";
  import am4themes_animated from "@amcharts/amcharts4/themes/animated";
  import { getCookie, setCookie } from '@/assets/js/elffy_js/cookie.js'

  export default {
    name: 'clients',
    data() {
      return {
        company_users: [],
        current_year: '',
        deals_data: '',
        stages_data: '',
        year_range: '',
        filter_sales: 'all',
        filter_year: '',
        current_user_name: '',
        deals_title: ['won','all','lost'],
        stages_name: [],
        chart_data: [],
        chart_funnel_data: []
      }
    },
    created() {
      this.getSales();
    },
    props: ['toggle_aside'],
    computed:{
      avgPrice(){
        if(this.deals_data)
          var avg = this.deals_data.total['won'] / this.deals_data.count['won']
          if (isNaN(avg))
            avg = 0
          return 'NT$ ' + avg.toLocaleString();
      },
      allValue(){
        return  this.company_users.reduce((a, b) => a + b.total_target, 0)
      },
      allTarget(){
        return  this.company_users.reduce((a, b) => a + b.expect_target, 0)
      },
      orderedUserByValue: function () {
        //return this.quotation_items
        return _.orderBy(this.company_users, 'total_target')
      },
    },
    methods: {
      dealCount(title){
        if(this.deals_data)
          return this.deals_data.count[title]
      },
      floatRound(f){
        return ((Math.round(f*1000)/10)).toString() + "%"
      },
      dealTotal(title) {
        if(this.deals_data)
          return '$ ' + this.deals_data.total[title].toLocaleString();
      },
      dealRate(title) {
        if(this.deals_data)
           if (this.deals_data.count['all'] == 0 && this.deals_data.count[title] == 0)
            return '0%'
          else
            return (this.deals_data.count[title]/this.deals_data.count['all']*100).toFixed(2) + '%'
      },
      stageRate(stage_count){
        var first_stage = this.stages_name[0]
        if (stage_count == 0 && this.stages_data[first_stage] == 0)
          return '0%'
        else
        return (stage_count / this.stages_data[first_stage] * 100).toFixed(2) + '%'
      },
      transferRate(stage_count, name){
        if (name == this.stages_name[0] && stage_count==0)
          return '0%'
        else if (name == this.stages_name[0])
          return '100%'


        var previous_index = this.stages_name.indexOf(name) - 1
        var previous_stage = this.stages_name[previous_index]
        if (stage_count == 0 && this.stages_data[previous_stage] == 0)
          return '0%'
        else
          return (stage_count / this.stages_data[previous_stage] * 100).toFixed(2) + '%'
      },
      getSales(){
        const vm = this;
        // user access token
        vm.auth_token = { 'Auth-Token': getCookie('auth_token') }
        this.axios.get('analytics/sales').then(
          function(response) {
            if (response.status == 200 && response['data']['data']) {
              // company_users
              vm.company_users = response['data']['data']['company_users']
              // initial deal_owner_user
              // vm.filter_sales = response['data']['data']['current_user']['id']

              vm.current_user_name = response['data']['data']['current_user']['name']
              vm.filter_year = response['data']['data']['current_year']
              vm.year_range = response['data']['data']['year_range']
              vm.deals_data = response['data']['data']['deals_data']
              vm.stages_data = response['data']['data']['stages_data']
              vm.stages_name = response['data']['data']['stages_name']
              vm.chart_data = response['data']['data']['chart_data']
              vm.chart_funnel_data = response['data']['data']['chart_funnel_data']
              vm.generateChart(vm.chart_data)
            } else if (response.status == 200 && response['data']['status'] == 'fail') {
              console.log('Error')
            }
          }).catch(function(error) {
          console.log('error:', error)
        });
      },
      queryData(){
        const vm = this;
        // user access token
        vm.auth_token = { 'Auth-Token': getCookie('auth_token') }
        this.axios.get('analytics/query_sales_data', {
          params: {
            'sales': {'id': vm.filter_sales, 'year': vm.filter_year},
            }
          }).then(
          function(response) {
            if (response.status == 200 && response['data']['data']) {
              vm.current_user_name = response['data']['data']['current_user']['name']
              vm.deals_data = response['data']['data']['deals_data']
              vm.stages_data = response['data']['data']['stages_data']
              vm.chart_data = response['data']['data']['chart_data']
              vm.chart_funnel_data = response['data']['data']['chart_funnel_data']
              vm.company_users = response['data']['data']['company_users']
              vm.generateChart(vm.chart_data)
            } else if (response.status == 200 && response['data']['status'] == 'fail') {
              console.log('Error')
            }
          }).catch(function(error) {
        });
      },
      generateChart(chart_data){
        am4core.useTheme(am4themes_animated);
        //圖表1 營業額
        let chart = am4core.create(this.$refs.chartdiv, am4charts.XYChart);
        // Add data
        chart.data = this.chart_data

        // Create axes
        var dateAxis = chart.xAxes.push(new am4charts.DateAxis());
        //dateAxis.dataFields.category = "category";
        dateAxis.baseInterval = {
          "timeUnit": "month",
          "count": 1
        } 
        dateAxis.dateFormats.setKey("month", "MMM");

        var valueAxis = chart.yAxes.push(new am4charts.ValueAxis());

        // Create series
        var series = chart.series.push(new am4charts.ColumnSeries());
        series.dataFields.valueY = "totalmoney";
        series.dataFields.dateX = "date";
        series.name = "每月營業額";
        series.tooltipText = "NT$ {valueY}";

        // Create scrollbars
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();
        chart.legend = new am4charts.Legend();

        /* Create a cursor */
        chart.cursor = new am4charts.XYCursor();
        this.chart = chart;

        //圖表2 銷售漏斗
        let chart2 = am4core.create(this.$refs.chart_funnel, am4charts.SlicedChart);

        chart2.data = this.chart_funnel_data;
        let series2 = chart2.series.push(new am4charts.FunnelSeries());
        series2.dataFields.value = "value";
        series2.dataFields.category = "name";
        series2.alignLabels = true;
        series2.labels.template.text = "{category}: [bold]{value}[/] 筆";

        var fillModifier2 = new am4core.LinearGradientModifier();
        fillModifier2.brightnesses = [-0.5, 1, -0.5];
        fillModifier2.offsets = [0, 0.5, 1];
        series2.slices.template.fillModifier = fillModifier2;

        series2.sliceLinks.template.height = 0;
        this.chart2 = chart2;


        //圖表3 團隊績效狀況，選擇所有人的時候才會出現團隊數據
        if(this.filter_sales=="all"){
          let chart3 = am4core.create(this.$refs.chart_team_revenue, am4charts.XYChart);
          chart3.hiddenState.properties.opacity = 0; // this creates initial fade-in

          chart3.paddingBottom = 30;
          var chart3_data = []
          $.each(this.company_users,function(i,user){
            var user_data={
              "name": user.user_name,
              "steps": user.total_target,
              "avatar": user.avatar
            }
            console.log('user_data',user_data)
            chart3_data.push(user_data)
          })
          chart3.data = chart3_data

          var categoryAxis3 = chart3.xAxes.push(new am4charts.CategoryAxis());
          categoryAxis3.dataFields.category = "name";
          categoryAxis3.renderer.grid.template.strokeOpacity = 0;
          categoryAxis3.renderer.minGridDistance = 10;
          categoryAxis3.renderer.labels.template.dy = 35;
          categoryAxis3.renderer.tooltip.dy = 35;

          var valueAxis3 = chart3.yAxes.push(new am4charts.ValueAxis());
          valueAxis3.renderer.inside = true;
          valueAxis3.renderer.labels.template.fillOpacity = 0.3;
          valueAxis3.renderer.grid.template.strokeOpacity = 0;
          valueAxis3.min = 0;
          valueAxis3.cursorTooltipEnabled = false;
          valueAxis3.renderer.baseGrid.strokeOpacity = 0;

          var series3 = chart3.series.push(new am4charts.ColumnSeries);
          series3.dataFields.valueY = "steps";
          series3.dataFields.categoryX = "name";
          series3.dataFields.categoryY = "avatar";
          series3.tooltipText = "{valueY.value}";
          series3.tooltip.pointerOrientation = "vertical";
          series3.tooltip.dy = - 6;
          series3.columnsContainer.zIndex = 100;

          var columnTemplate3 = series3.columns.template;
          columnTemplate3.width = am4core.percent(50);
          columnTemplate3.maxWidth = 66;
          columnTemplate3.column.cornerRadius(60, 60, 10, 10);
          columnTemplate3.strokeOpacity = 0;

          series3.heatRules.push({ target: columnTemplate3, property: "fill", dataField: "valueY", min: am4core.color("#e5dc36"), max: am4core.color("#5faa46") });
          series3.mainContainer.mask = undefined;

          var cursor3 = new am4charts.XYCursor();
          chart3.cursor = cursor3;
          cursor3.lineX.disabled = true;
          cursor3.lineY.disabled = true;
          cursor3.behavior = "none";

          var bullet3 = columnTemplate3.createChild(am4charts.CircleBullet);
          bullet3.circle.radius = 30;
          bullet3.valign = "bottom";
          bullet3.align = "center";
          bullet3.isMeasured = true;
          bullet3.mouseEnabled = false;
          bullet3.verticalCenter = "bottom";
          bullet3.interactionsEnabled = false;

          var hoverState3 = bullet3.states.create("hover");
          var outlineCircle3 = bullet3.createChild(am4core.Circle);
          outlineCircle3.adapter.add("radius", function (radius, target) {
              var circleBullet = target.parent;
              return circleBullet.circle.pixelRadius + 10;
          })

          var image3 = bullet3.createChild(am4core.Image);
          image3.width = 60;
          image3.height = 60;
          image3.horizontalCenter = "middle";
          image3.verticalCenter = "middle";

          image3.adapter.add("href", function (href, target) {
              var dataItem = target.dataItem;
              if (dataItem) {
                  return dataItem.categoryY;
              }
          })


          image3.adapter.add("mask", function (mask, target) {
              var circleBullet = target.parent;
              return circleBullet.circle;
          })

          var previousBullet;
          chart3.cursor.events.on("cursorpositionchanged", function (event) {
              var dataItem = series.tooltipDataItem;

              if (dataItem.column) {
                  var bullet = dataItem.column.children.getIndex(1);

                  if (previousBullet && previousBullet != bullet) {
                      previousBullet.isHover = false;
                  }

                  if (previousBullet != bullet) {

                      var hs = bullet3.states.getKey("hover");
                      hs.properties.dy = -bullet3.parent.pixelHeight + 30;
                      bullet3.isHover = true;

                      previousBullet = bullet3;
                  }
              }
          })

          this.chart3 = chart3;
        } 
      }
    },
  }
</script>


// WEBPACK FOOTER //
// Sales.vue?4b338300